import axios from "axios";

const BASE_API_URL = "/api/auth";

//—— localStorage 安全存取 ——
//  瀏覽器封鎖網站資料時（Safari 無痕、隱私設定、被嵌在限制 storage 的 iframe 裡），
//  連「讀取 localStorage 這個屬性」本身都會直接 throw SecurityError。
//  沒有防護的話整個 app 會在第一次讀取時白畫面 —— 這裡一律包起來，
//  失敗就當作沒有資料，使用者頂多需要重新登入，而不是整站打不開。
const safeGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    //存不進去就算了：登入狀態的真相是後端的 cookie，
    //localStorage 只是拿來避免每次進站都要重打 /me
  }
};

const safeRemove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    //同上
  }
};

//認證 service
//
//  token 存在 httpOnly cookie，前端讀不到也不需要讀 —— localStorage 只放 profile 給 UI 顯示。
//  「登入狀態」以 login_status 這個旗標為準，重新整理時再打 /me 跟後端對答案。
class AuthService {
  //登出：fire-and-forget 呼叫後端清 httpOnly cookie，本地立即清掉 user / login_status
  logout() {
    axios.post(BASE_API_URL + "/logout").catch(() => {}); //後端清不掉也沒關係，本地一定會清
    safeRemove("user");
    safeSet("login_status", "false");
    window.dispatchEvent(new CustomEvent("user-updated", { detail: null }));
  }

  //登入成功後存 profile
  //  廣播 user-updated → 讓已 mount 的 nav / 其他元件同步刷新登入狀態
  login(profile) {
    safeSet("user", JSON.stringify(profile));
    safeSet("login_status", "true");
    window.dispatchEvent(new CustomEvent("user-updated", { detail: profile }));
  }

  updateUserInfo(profile) {
    safeSet("user", JSON.stringify(profile));
    window.dispatchEvent(new CustomEvent("user-updated", { detail: profile }));
  }

  getLoginStatus() {
    return safeGet("login_status") === "true";
  }

  getUserProfile() {
    try {
      return JSON.parse(safeGet("user"));
    } catch (e) {
      //內容被手動改壞、不是合法 JSON 時不要讓整個 app 掛掉
      return null;
    }
  }

  //Google 登入：client 拿 Google 簽發的 ID Token，後端用 google-auth-library 驗證
  //  Web 的 token 來自 Google Identity Services，App 來自原生 Google Sign-In SDK，
  //  兩邊打同一支 API（後端的 audience 檢查會接受多組 client ID）
  //  options:
  //    deviceToken — 這台裝置目前的推播 token；Web 預設 ""
  //    osType     — "0" Web / "1" iOS / "2" Android
  googleLogin(idToken, { deviceToken = "", osType = "0" } = {}) {
    return axios.post(BASE_API_URL + "/google-login", {
      idToken,
      deviceToken,
      osType,
    });
  }

  //完成註冊（填完基本資料）
  registerFull(profile) {
    return axios.post(BASE_API_URL + "/register-full", profile);
  }

  //取回目前登入者：重新整理後用來確認 cookie 還有效
  me() {
    return axios.get(BASE_API_URL + "/me");
  }
}

//單例：全站共用同一個實例，避免每個元件各自 new 一份
const authService = new AuthService();
export default authService;
